<template>
  <div
    v-click-outside="hide"
    class="d-flex flex-column"
  >
    <div
      class="d-flex flex-column position-relative"
    >
      <label
        v-if="label"
        style="margin-bottom: 0.5rem !important;"
      >
        {{ label }}
      </label>
      <input
        id="countrye-research"
        placeholder="Allemagne"
        type="search"
        class="form-control"
        @focus="focusInput"
        @input="search($event.target.value)"
        @blur="zindex = false"
      >
    </div>
    <div
      v-if="open"
      class="position-relative"
      style="max-height:250px;"
    >
      <transition
        tag="div"
        name="slide"
      >
        <div
          class="position-absolute border-2 border-gray-400 d-flex
            flex-column w-100 bg-white text-gray-600 card my-3"
          style="z-index: 21; max-height:270px; overflow-y:scroll"
        >
          <div v-if="researchCountries.length > 0">
            <div
              v-for="researchCountry in researchCountries"
              :key="researchCountry.code"
              class="researched-country d-flex flex-wrap border-bottom align-items-center px-2"
              style="min-height: 64px"
              @click="dispatchAction(researchCountry.item)"
              v-html="breadcrumb(researchCountry, 'd-flex flex-row flex-wrap')"
            />
          </div>
          <div v-else>
            <div
              v-for="country in allCountries"
              :key="country.code"
              class="researched-country d-flex flex-wrap border-bottom align-items-center px-2"
              style="min-height: 64px"
              @click="dispatchAction(country)"
            >
              <div class="my-auto text-left">
                {{ country.name }}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash-es';
import { mapGetters } from 'vuex';

import ClickOutside from 'vue-click-outside';

import { ui, routing } from '@/mixins';
import { breadcrumb } from '@/utils/countries';

export default {
  directives: { ClickOutside },
  mixins: [ui, routing],
  props: {
    label: {
      type: String,
      default: '',
    },
    debounceTimer: {
      type: Number,
      default: 500,
    },
    // callback to use when a selector is clicked
    itemAction: {
      type: Function,
      default: (value) => value,
    },
    list: {
      type: [Array, null],
      default: () => [],
    },
  },
  data() {
    return {
      zindex: false,
      open: false,
      breadcrumb,
      term: null,
      debouncer: ({ cancel: () => {} }),
      researchCountries: [],
    };
  },
  computed: {
    ...mapGetters({
      allCountries: 'contracts/countries',
    }),
  },
  methods: {
    search(value) {
      this.debouncer.cancel();
      const debouncerFunction = () => {
        this.term = value;
        this.$store.dispatch('employee/search', { value, list: this.list })
          .then((results) => { this.researchCountries = results; });
      };
      this.debouncer = debounce(debouncerFunction, this.debounceTimer);
      this.debouncer();
    },
    dispatchAction(item) {
      this.open = false;
      this.itemAction(item);
    },
    focusInput(event) {
      if (event.target.value && event.target.value.length > 0) {
        this.$store.dispatch('employee/search', { value: event.target.value, list: this.list })
          .then((results) => { this.researchCountries = results; });
      }
      this.open = true;
      this.zindex = true;
    },
    hide() {
      this.open = false;
      this.zindex = false;
    },
  },
};
</script>
<style scoped>
.researched-country:hover{
  cursor: pointer;
  background-color: #EDF4FD;
}
</style>
